import {
  GET_DEBT_NOTICE,
  GET_DEBT_NOTICE_FINANCIAL_RESPONSIBLE,
  DEBT_NOTICE_DATA,
  DEBT_NOTICE_ERROR,
  DEBT_NOTICE_LOADING,
} from 'store/constants'

export const initialState = {
  data: [],
  loading: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DEBT_NOTICE:
    case GET_DEBT_NOTICE_FINANCIAL_RESPONSIBLE:
      return { ...state, loading: true, error: null }
    case DEBT_NOTICE_DATA:
      return { ...state, loading: false, data: action?.payload || [], error: null }
    case DEBT_NOTICE_ERROR:
      return { ...state, loading: false, error: action.payload }
    case DEBT_NOTICE_LOADING:
      return { ...state, loading: action.payload }
    default:
      return state
  }
}
